import { useNavigate } from "react-router-dom";
import { AGREEMENT_SECTIONS, AGREEMENT_TITLE } from "../../beta/agreement";
import { recordAcceptance } from "../../beta/store";
import BetaLayout from "./BetaLayout";

export default function BetaAgreement() {
  const navigate = useNavigate();

  function accept() {
    recordAcceptance();
    navigate("/beta/profile");
  }

  return (
    <BetaLayout>
      <article className="beta-card beta-card--wide">
        <p className="beta-kicker">Click “Accept &amp; Continue” to proceed</p>
        <h1>{AGREEMENT_TITLE}</h1>
        <div className="beta-agreement">
          {AGREEMENT_SECTIONS.map((section) => (
            <section key={section.heading}>
              <h2>{section.heading}</h2>
              {section.paragraphs.map((paragraph) => (
                <p key={paragraph.slice(0, 48)}>{paragraph}</p>
              ))}
            </section>
          ))}
        </div>
        <div className="beta-actions">
          <button type="button" className="btn" onClick={accept}>
            Accept &amp; Continue
          </button>
        </div>
      </article>
    </BetaLayout>
  );
}
